  import React, { useState, useRef, useEffect } from "react";
  import { useHistory } from "react-router-dom";
  import { Button } from "primereact/button";
  import { useFormik } from "formik";
  import axios from "axios";
  import * as Yup from "yup";
  import { InputText } from "primereact/inputtext";
  import { classNames } from "primereact/utils";
  import { useDispatch, useSelector } from "react-redux";
  import { Toast } from "primereact/toast";
  import { loginAdminUser } from "../../redux/actions/user_actions";
  import { Password } from "primereact/password";
  import appUrl from "../../config/appUrl";
  import leParkLogo from "../../../assets/images/leParkLogo.png"
  import BannerLogin from "../../../assets/images/Banner_login.png"

  const LoginScreen = () => {
    const loginUserReducer = useSelector((state) => state.loginUser);
    const { user, loading, error, success } = loginUserReducer;
    const dispatch = useDispatch();

    const toast = useRef(null);
    const history = useHistory();

    const [value, setValue] = useState("");

    const validationSchema = Yup.object().shape({
      // password: Yup.string()
      //   .required("This field is required.")
      //   .min(8, "Minimum length should be 8"),
      email: Yup.string().required("This field is required."),
    });

    const formik = useFormik({
      initialValues: {
        email: "",
        password: "",
      },
      validationSchema: validationSchema,
      onSubmit: async (data) => {
        dispatch(loginAdminUser(data));
      },
    });

    const isFormFieldValid = (name) =>
      !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
      return (
        isFormFieldValid(name) && (
          <small className="p-error">{formik.errors[name]}</small>
        )
      );
    };

    useEffect(() => {
      if (success !== undefined) {
        if (success === false) {
          toast.current.show({
            severity: "error",
            summary: "Error Message",
            detail: error,
            life: 3000,
          });
        }
      }
    }, [success, user]);

  return (
    <div
    
    >
      <Toast ref={toast} />

      <div className="grid m-0" style={{ minHeight: "100vh" }}>

        {/* LEFT SIDE */}
        <div
          className="col-12 md:col-6"
          style={{
            backgroundImage: `url(${BannerLogin})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "100vh",
          }}
        >
        
          {/* Optional Content */}
        </div>

        {/* RIGHT SIDE */}
        <div
          className="col-12 md:col-6 flex justify-content-center align-items-center"
          style={{ minHeight: "100vh" }}
        >
          <div className="card Login__card auth_main_login">
            <form onSubmit={formik.handleSubmit}>
              <div className="grid p-fluid">
                <div className="col-12">
                  <div>
                    <div
                      className="text-center parking-title"
                      style={{ justifyContent: "center" }}
                    >
                      <div align="center">
                        <img
                          src={leParkLogo}
                          alt="logo"
                          style={{ width: "290px" }}
                        />
                      </div>

                      <p className="mt-3 login-title">
                        Parking System
                      </p>
                    </div>

                    <div className="text-center login-title">
                      <p>Log in to your account</p>
                    </div>

                    <div className="mt-3 mb-8 text-center welcome-text">
                      <p>
                        Welcome back! Please enter login details.
                      </p>
                    </div>
                  </div>

                  {/* EMAIL */}
                  <div className="mb-4 mt-2 w-full">
                    <label
                      htmlFor="email"
                      className="email_label font_14"
                    >
                      Email
                    </label>

                    <InputText
                      id="email"
                      type="text"
                      name="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      className={classNames(
                        {
                          "p-invalid": isFormFieldValid("email"),
                        },
                        "mt-2 font_14 custom-input-login"
                      )}
                    />

                    {getFormErrorMessage("email")}
                  </div>

                  {/* PASSWORD */}
                  <div className="col-12 mb-2 mt-2 pr-0 pl-0">
                    <label
                      htmlFor="password"
                      className="font_14"
                    >
                      Password
                    </label>

                    <Password
                      id="password" 
                      name="password"
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      toggleMask
                      feedback={false}
                      className={classNames(
                        {
                          "p-invalid": isFormFieldValid("password"),
                        },
                        "mt-2 font_14 w-full custom-input-login"
                      )}
                      inputClassName="w-full"
                    />

                    {getFormErrorMessage("password")}
                  </div>
                </div>

                {/* BUTTON */}
                <div className="col-12 mb-5 mt-2 text-center">
                  <div className="btn__main">
                    <Button
                      loading={loading}
                      type="submit"
                      label="Login"
                      className="login__btn w-full font_14"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
  };

  export default LoginScreen;
